<mat-card class="cur-card">
    <mat-card-content>
        <!-- 上段 -->
        <div class="tw-flex tw-flex-row tw-box-border tw-justify-start tw-items-center tw-content-center">
            <mat-form-field appearance="outline" class="input-form-basic-info"
                class="input-form-basic-info tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[15%]">
                <mat-label>エネルギー種別</mat-label>
                <input disabled class="font-color-display-only" readonly="true" matInput autocomplete="off"
                    [value]="suppntInfo.energyClsfyCodeaname" id="energyClsfyCodeaname" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="input-form-basic-info"
                class="input-form-basic-info tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[25%]">
                <mat-label>供給地点特定番号</mat-label>
                <input disabled class="font-color-display-only" readonly="true" matInput autocomplete="off"
                    [value]="suppntInfo.suppntSpno" id="suppntSpno" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="input-form-basic-info"
                class="input-form-basic-info tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[44%]">
                <mat-label>使用者名</mat-label>
                <input disabled class="font-color-display-only" readonly="true" matInput autocomplete="off"
                    [value]="siyoushamei" id="siyoushamei" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="input-form-basic-info"
                class="input-form-basic-info tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[16%]">
                <mat-label>作業種別</mat-label>
                <input disabled class="font-color-display-only" readonly="true" matInput autocomplete="off"
                    [value]="suppntInfo.workClscodeAname" id="workClscodeAname" />
            </mat-form-field>
        </div>
        <!-- 中段-->
        <div class="tw-flex tw-flex-row tw-box-border tw-flex-wrap tw-justify-start tw-items-center tw-content-center">
            <mat-form-field appearance="outline" class="input-form-basic-info"
                class="input-form-basic-info tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[15%]">
                <mat-label>メーター番号</mat-label>
                <input disabled class="font-color-display-only" readonly="true" matInput autocomplete="off"
                    [value]="suppntInfo.meterNo" id="meterNo" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="input-form-basic-info"
                class="input-form-basic-info tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[10%]">
                <mat-label>型</mat-label>
                <input disabled class="font-color-display-only" readonly="true" matInput autocomplete="off"
                    [value]="suppntInfo.meterKata" id="meterKata" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="input-form-basic-info"
                class="input-form-basic-info tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[12%]">
                <mat-label>能力</mat-label>
                <input disabled class="font-color-display-only" readonly="true" matInput autocomplete="off"
                    [value]="suppntInfo.meterAbility" id="meterAbility" />
            </mat-form-field>

            <mat-form-field appearance="outline"
                class="input-form-basic-info tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[17%]">
                <mat-label>接続形態</mat-label>
                <input disabled class="font-color-display-only" [value]="suppntInfo.meterCnnctformCodeaname" matInput
                    autocomplete="off" id="meterCnnctformCodeaname" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="input-form-basic-info"
                class="input-form-basic-info tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[10%]">
                <mat-label>親/子</mat-label>
                <input disabled class="font-color-display-only" readonly="true" matInput autocomplete="off"
                    [value]="suppntInfo.meterDiscrmAname" id="meterDiscrmAname" />
            </mat-form-field>
        </div>
        <!-- 下段-->
        <div class="tw-flex tw-flex-row tw-box-border tw-flex-wrap tw-justify-start tw-items-center tw-content-center">

            <mat-form-field appearance="outline"
                class="input-form-basic-info tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[17%]">
                <mat-label>取付位置</mat-label>
                <input disabled class="font-color-display-only" [value]="suppntInfo.meterInstallationlocationCodeaname" matInput
                autocomplete="off" id="meterInstallationlocationCodeaname" />
            </mat-form-field>

            <mat-form-field appearance="outline"
                class="input-form-basic-info tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[17%]">
                <mat-label>内外理由メーター</mat-label>
                <input disabled class="font-color-display-only" [value]="suppntInfo.meterinneroutercodeAname" matInput
                    autocomplete="off" id="meterinneroutercodeAname" />
            </mat-form-field>

            <mat-form-field appearance="outline"
                class="input-form-basic-info tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[17%]">
                <mat-label>内外理由ガス栓</mat-label>
                <input disabled class="font-color-display-only" [value]="suppntInfo.meterGassenuchisotoCodeaname" matInput
                    autocomplete="off" id="meterGassenuchisotoCodeaname" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="input-form-basic-info"
                class="input-form-basic-info tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[15%]">
                <mat-label>総合/被総合</mat-label>
                <input disabled class="font-color-display-only" readonly="true" matInput autocomplete="off"
                    [value]="suppntInfo.sougoudivCodeAname" id="sougoudivCodeAname" />
            </mat-form-field>

        </div>
    </mat-card-content>
</mat-card>

<mat-card class="cur-card">
    <mat-card-content>

        <div lass="tw-flex tw-flex-row tw-box-border tw-justify-start tw-items-center tw-content-center"
            style=" display: flex;">
            <mat-form-field appearance="outline" class="input-form-basic-info"
                class="tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[25%]">
                <mat-label>支払契約番号</mat-label>
                <input disabled class="font-color-display-only" readonly="true" matInput autocomplete="off"
                    [value]="clmtoInfo.payCtrNo" id="payCtrNo" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="input-form-basic-info"
                class="tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[15%]">
                <mat-label>合算/まとめ</mat-label>
                <input disabled class="font-color-display-only" readonly="true" matInput autocomplete="off"
                    [value]="clmtoInfo.mtmclmDivAname" id="mtmclmDivAname" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="input-form-basic-info"
                class="tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[50%]">
                <mat-label>請求先名</mat-label>
                <input disabled class="font-color-display-only" readonly="true" matInput autocomplete="off"
                    [value]="seikyusakimei" id="seikyusakimei" />
            </mat-form-field>
        </div>
    </mat-card-content>
</mat-card>